import type { EmbarcacaoDetailSectionProps } from "../../embarcacao-detail-section";
import { useConsumoOperacaoSection } from "./use-consumo-operacao-section";
import { ConsumoOperacaoSectionView } from "./view-consumo-operacao-section";

export function ConsumoOperacaoSection(props: EmbarcacaoDetailSectionProps) {
  const vm = useConsumoOperacaoSection(props);

  return <ConsumoOperacaoSectionView {...vm} />;
}

export type * from "./types-consumo-operacao-section";
